/**
 * Catalogue Produits — i-talit.com
 * Filtres client-side + tri + toggle panneau
 */
(function () {
  'use strict';

  const $ = id => document.getElementById(id);
  const qsa = (sel, ctx) => [...(ctx || document).querySelectorAll(sel)];

  const filterPanel  = $('itcat-filters');
  const filterBtn    = $('itcat-filter-btn');
  const filtersClose = $('itcat-filters-close');
  const sortSelect  = $('itcat-sort');
  const countNum    = $('itcat-count-num');
  const filterCount = $('itcat-filter-count');
  const clearBtn    = $('itcat-clear-btn');
  const emptyEl     = $('itcat-empty');
  const emptyReset  = $('itcat-empty-reset');
  const toolbar     = document.querySelector('.itcat__toolbar');
  const backdrop    = $('itcat-backdrop');
  const grid        = $('itcat-grid');

  if (!filterPanel || !grid) return;

  let cards = qsa('.itcat__card', grid);
  let activeFilters = { collection: [], availability: [], type: [], tag: [] };

  // ─── TOGGLE PANNEAU FILTRES ───────────────────────────────────────────────

  const isDrawer = () => window.innerWidth <= 1100;

  function openFilters() {
    filterPanel.classList.add('is-open');
    filterBtn.classList.add('is-active');
    filterBtn.setAttribute('aria-expanded', 'true');
    filterPanel.setAttribute('aria-hidden', 'false');
    // Backdrop sur tablette et mobile (mode drawer)
    if (backdrop && isDrawer()) {
      backdrop.style.display = 'block';
      requestAnimationFrame(() => { backdrop.style.opacity = '1'; });
    }
  }

  function closeFilters() {
    filterPanel.classList.remove('is-open');
    filterBtn.classList.remove('is-active');
    filterBtn.setAttribute('aria-expanded', 'false');
    filterPanel.setAttribute('aria-hidden', 'true');
    if (backdrop) {
      backdrop.style.opacity = '0';
      setTimeout(() => { backdrop.style.display = 'none'; }, 300);
    }
  }

  filterBtn.addEventListener('click', () => {
    const isOpen = filterPanel.classList.contains('is-open');
    isOpen ? closeFilters() : openFilters();
  });

  if (backdrop) {
    backdrop.addEventListener('click', closeFilters);
  }

  if (filtersClose) {
    filtersClose.addEventListener('click', () => {
      closeFilters();
      filterBtn.focus();
    });
  }

  // Fermer avec Échap
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && filterPanel.classList.contains('is-open')) {
      closeFilters();
      filterBtn.focus();
    }
  });

  // ─── TOGGLE GROUPES DE FILTRES ────────────────────────────────────────────

  qsa('.itcat__filter-group-toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
    });
  });

  // ─── FILTRES ──────────────────────────────────────────────────────────────

  qsa('.itcat__checkbox').forEach(cb => {
    cb.addEventListener('change', () => {
      const name = cb.name;
      if (!activeFilters[name]) activeFilters[name] = [];

      if (cb.checked) {
        activeFilters[name].push(cb.value);
      } else {
        activeFilters[name] = activeFilters[name].filter(v => v !== cb.value);
      }

      applyFilters();
      updateFilterBadge();
    });
  });

  function applyFilters() {
    const { collection, availability, type, tag } = activeFilters;
    let visible = 0;

    cards.forEach(card => {
      const cardCollections = card.dataset.collections || '';
      const cardAvailable   = card.dataset.available === 'true';
      const cardType        = (card.dataset.type || '').toLowerCase().trim();
      const cardTags        = (card.dataset.tags || '').toLowerCase();

      let show = true;

      // Coutume (collection)
      if (collection.length > 0) {
        show = collection.some(c => cardCollections.includes(c));
      }

      // Disponibilité
      if (show && availability.length > 0) {
        const wantIn  = availability.includes('instock');
        const wantOut = availability.includes('outofstock');
        if (wantIn && !wantOut)       show = cardAvailable;
        else if (wantOut && !wantIn)  show = !cardAvailable;
        // Les deux cochés → tout afficher
      }

      // Type de produit
      if (show && type.length > 0) {
        show = type.some(t => cardType.includes(t));
      }

      // Tag (ex. Économique)
      if (show && tag.length > 0) {
        show = tag.some(t => cardTags.includes(t.toLowerCase()));
      }

      card.dataset.hidden = show ? 'false' : 'true';
      if (show) visible++;
    });

    // Compteur
    countNum.textContent = visible;

    // État vide (uniquement si des filtres sont actifs)
    const hasActiveFilters = Object.values(activeFilters).flat().length > 0;
    emptyEl.hidden = !(hasActiveFilters && visible === 0);
    grid.style.display = (hasActiveFilters && visible === 0) ? 'none' : '';
  }

  // ─── EFFACER FILTRES ──────────────────────────────────────────────────────

  function clearAll() {
    qsa('.itcat__checkbox').forEach(cb => { cb.checked = false; });
    activeFilters = { collection: [], availability: [], type: [], tag: [] };
    applyFilters();
    updateFilterBadge();
  }

  clearBtn.addEventListener('click', clearAll);
  emptyReset.addEventListener('click', clearAll);

  // ─── BADGE FILTRE ACTIF ───────────────────────────────────────────────────

  function updateFilterBadge() {
    const total = Object.values(activeFilters).flat().length;
    filterCount.textContent = total;
    filterCount.hidden = total === 0;
    clearBtn.hidden = total === 0;
  }

  // ─── TRI ──────────────────────────────────────────────────────────────────

  sortSelect.addEventListener('change', () => {
    const val = sortSelect.value;
    // Récupérer les cartes dans leur ordre DOM actuel
    cards = qsa('.itcat__card', grid);

    const sorted = [...cards].sort((a, b) => {
      switch (val) {
        case 'price-asc':
          return Number(a.dataset.price) - Number(b.dataset.price);
        case 'price-desc':
          return Number(b.dataset.price) - Number(a.dataset.price);
        case 'title-asc':
          return (a.dataset.title || '').localeCompare(b.dataset.title || '', 'fr');
        case 'title-desc':
          return (b.dataset.title || '').localeCompare(a.dataset.title || '', 'fr');
        default: // featured — ordre original Shopify
          return Number(a.dataset.order) - Number(b.dataset.order);
      }
    });

    // Réinjecter dans le DOM dans le nouvel ordre
    const frag = document.createDocumentFragment();
    sorted.forEach(card => frag.appendChild(card));
    grid.appendChild(frag);

    cards = sorted;
    applyFilters();
  });

  // ─── OMBRE TOOLBAR AU SCROLL ──────────────────────────────────────────────

  if (toolbar) {
    window.addEventListener('scroll', () => {
      toolbar.classList.toggle('is-scrolled', window.scrollY > 8);
    }, { passive: true });
  }

  // ─── OUVERTURE AUTOMATIQUE AU CHARGEMENT (desktop > 1100px uniquement) ────
  if (window.innerWidth > 1100) {
    openFilters();
  }

})();
